import React from 'react';

/** Bordered white panel — replaces MUI Paper/Card. */
const Card = ({ children, className = '', padding = true, ...rest }) => (
  <div
    className={`rounded-lg border border-[#E9EDF6] bg-white shadow-[0_1px_2px_rgba(15,23,42,0.04)] ${
      padding ? 'p-4' : ''
    } ${className}`}
    {...rest}
  >
    {children}
  </div>
);

export default Card;
